import { APP_SETTING } from "../../actions/type";
export default function access(state={},action){
    switch(action.type){
        case APP_SETTING:
            return action.payload;
        default:
            return state
    }
}